__webpack_require__.p = "/seedsigner-satochip-workshop/";